import config from '../module.config';
import { IModuleConfig } from './types';
import { ObjectUtils } from './utils';

export const moduleConfig: IModuleConfig = {
  translate: ObjectUtils.getIn(config, 'translate', () => ''),
  getLocaleList: ObjectUtils.getIn(config, 'getLocaleList', () => []),
};
